import {Spinner, Stack} from 'react-bootstrap'

interface Props {
  productStatus: any
  reload: any
}

export default function ProductStatus({
  productStatus,
  reload
}: Props) {
  return (
    <div className='card card-flush card-border mb-5 mb-xl-110' style={{minHeight:'434px'}}>
      <Stack gap={2} className='container mt-5 mb-5 ms-4'>
        <div className='text-dark fw-bolder fs-4'>Top Selling Products</div>
        <Stack direction='horizontal' gap={2}>
          <div className='fw-bold fs-7 text-dark'>{productStatus?.tpvAccepted}</div>
          <div className='text-muted fs-7 fw-semibold'>Products Sold</div>
        </Stack>
      </Stack>

      {reload ? (
        <div className="text-center mb-20">
          <Spinner animation="border" className="text-gray-600 text-center" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div
          className='container mb-5 hover-scroll-overlay-y mh-335px'
          style={{minHeight:'335px', maxHeight: '335px'}}
          data-kt='scroll'
          data-kt-activate='true'
          data-kt-scroll-height='auto'
        >
          {productStatus &&
            productStatus?.products.map((productData: any, index: any) => {
              return (
                <>
                  <div
                    className='d-flex align-items-center flex-row-fluid flex-wrap mb-5 '
                    key={index}
                  >
                    <div className='flex-grow-1' style={{width: '217px', marginLeft: '12px'}}>
                      <span className='text-gray-700 fs-5 fw-bold'>{productData?.productName}</span>
                      <span className='text-muted fw-semibold d-block fs-7'>
                        {productData?.productBrand}
                      </span>
                    </div>
                    <span className='badge badge-light fw-bold my-2 mx-6'>
                      {productData?.tpvAcceptedCount}
                    </span>
                  </div>
                </>
              )
            })}
        </div>
      )}
    </div>
  )
}
